import React from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';

export enum SwitchState {
  LEFT = 'left',
  RIGHT = 'right',
}
interface SwitchProps {
  left: string;
  right: string;
  onChange: Function;
  switchState: SwitchState;
}

export const Switch: React.FC<SwitchProps> = props => {
  return (
    <div className={styles.switchContainer}>
      <label
        className={classNames({
          [styles.greyLabel]: props.switchState === SwitchState.RIGHT,
          [styles.leftLabel]: true,
        })}
      >
        {props.left}
      </label>
      <div className={styles.switch}>
        <input
          type="checkbox"
          className={styles.switchInput}
          id="customSwitch1"
          onClick={() => props.onChange()}
          checked={props.switchState === SwitchState.RIGHT}
        />
        <label
          htmlFor="customSwitch1"
          className={classNames({
            [styles.greyLabel]: props.switchState === SwitchState.LEFT,
            [styles.rightLabel]: true,
          })}
        >
          {props.right}
        </label>
      </div>
    </div>
  );
};
